import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import LanguageMenu from './language-menu.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import ThemeMenu from './theme-menu.jsx';
import {MenuSection} from '../menu/menu.jsx';

import menuBarStyles from './menu-bar.css';
import styles from './settings-menu.css';

import dropdownCaret from './dropdown-caret.svg';
import settingsIcon from './icon--settings.svg';

const getCurrentLocale = () => {
    if (typeof window !== 'undefined' && window.__scratchGuiLocale) {
        return String(window.__scratchGuiLocale).toLowerCase();
    }
    if (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang) {
        return String(document.documentElement.lang).toLowerCase();
    }
    return 'en';
};

const getSettingsLabel = () => (getCurrentLocale().startsWith('es') ? 'Configuracion' : 'Settings');

const SettingsMenu = ({
    isRtl,
    onRequestClose,
    onRequestOpen,
    settingsMenuOpen
}) => (
    <div
        className={classNames(menuBarStyles.menuBarItem, menuBarStyles.hoverable, menuBarStyles.themeMenu, {
            [menuBarStyles.active]: settingsMenuOpen
        })}
        onMouseUp={onRequestOpen}
    >
        <img
            src={settingsIcon}
        />
        <span className={styles.dropdownLabel}>
            {getSettingsLabel()}
        </span>
        <img src={dropdownCaret} />
        <MenuBarMenu
            className={menuBarStyles.menuBarMenu}
            open={settingsMenuOpen}
            place={isRtl ? 'left' : 'right'}
            onRequestClose={onRequestClose}
        >
            <MenuSection>
                <LanguageMenu onRequestCloseSettings={onRequestClose} />
                <ThemeMenu onRequestCloseSettings={onRequestClose} />
            </MenuSection>
        </MenuBarMenu>
    </div>
);

SettingsMenu.propTypes = {
    isRtl: PropTypes.bool,
    onRequestClose: PropTypes.func,
    onRequestOpen: PropTypes.func,
    settingsMenuOpen: PropTypes.bool
};

export default SettingsMenu;
